module.exports = __webpack_public_path__ + "img/10.8998148e.png";